// Support component names relative to this directory:
const layoutRequirePageContext = require.context("pages/layout", true);

import ReactRailsUJS from "react_ujs";
ReactRailsUJS.useContext(layoutRequirePageContext);
